const contact = {
  // page.tsx JSON-LD & breadcrumb
  'contact.jsonld.breadcrumb1': 'ホーム',
  'contact.jsonld.breadcrumb2': 'お問い合わせ',
  'contact.jsonld.orgName': '日本執事アカデミー',
  'contact.jsonld.parentOrg': '一般社団法人全日本執事協会',
  'contact.jsonld.addressLocality': '東京都江東区青海2-7-4',
  'contact.page.homeLink': 'ホーム',
  'contact.page.currentPage': 'お問い合わせ',
  'contact.page.lastUpdated': '最終更新: 2026年6月13日',
  'contact.page.backToTop': 'ページの先頭へ戻る',

  // HeroSection
  'contact.hero.homeLink': 'ホーム',
  'contact.hero.currentPage': 'お問い合わせ',
  'contact.hero.title': 'お問い合わせ',
  'contact.hero.titleEn': 'CONTACT',
  'contact.hero.lead': 'ご質問・ご相談は、以下のフォームよりお気軽にお寄せください。担当者より2営業日以内にご返信いたします。',
  'contact.hero.imgAlt': '受付カウンターで電話応対する執事の様子',

  // InquiryGuideCards
  'contact.guides.label': 'TOPICS',
  'contact.guides.title': '目的別のお問い合わせ窓口',
  'contact.guides.subtitleEn': 'Choose Your Inquiry Topic',
  'contact.guides.lead': 'お問い合わせの内容によっては、専用の窓口の方がスムーズな場合があります。用件に近いものをお選びください。',
  'contact.guides.0.title': '資料がほしい',
  'contact.guides.0.titleEn': 'Brochure Request',
  'contact.guides.0.description': 'コースの詳細やアカデミーの理念をまとめた資料を無料でお届けします。',
  'contact.guides.0.linkLabel': '資料請求はこちら（無料）',
  'contact.guides.1.title': 'コースを相談したい',
  'contact.guides.1.titleEn': 'Course Consultation',
  'contact.guides.1.description': '経験豊富なスタッフが、あなたの目標やご経験に合わせた最適なコース選びを無料でサポートします。',
  'contact.guides.1.linkLabel': '個別相談を予約する',
  'contact.guides.2.title': 'よくある質問',
  'contact.guides.2.titleEn': 'FAQ',
  'contact.guides.2.description': '受講に関するよくあるご質問とその回答をまとめています。まずはこちらをご覧ください。',
  'contact.guides.2.linkLabel': 'よくある質問を見る',
  'contact.guides.3.title': '法人研修',
  'contact.guides.3.titleEn': 'Corporate Training',
  'contact.guides.3.description': '企業向けの接遇・ビジネスマナー研修のご相談は、法人研修専用ページからお問い合わせください。',
  'contact.guides.3.linkLabel': '法人研修を見る',

  // ContactForm
  'contact.form.label': 'INQUIRY FORM',
  'contact.form.title': 'お問い合わせフォーム',
  'contact.form.subtitleEn': 'Contact Form',
  'contact.form.lead': '下記フォームより、ご質問・ご相談をお寄せください。',
  'contact.form.required': '必須',
  'contact.form.optional': '任意',
  'contact.form.altContact': 'フォームのほか、お電話',
  'contact.form.altOr': 'またはメール',
  'contact.form.altAccept': 'でも承ります。',
  'contact.form.name': '氏名',
  'contact.form.namePlaceholder': '例: 執事 太郎',
  'contact.form.nameError': '氏名は必須です',
  'contact.form.furigana': 'ふりがな',
  'contact.form.furiganaPlaceholder': '例: しつじ たろう',
  'contact.form.furiganaError': 'ふりがなは必須です',
  'contact.form.email': 'メールアドレス',
  'contact.form.emailPlaceholder': '例: taro@example.com',
  'contact.form.emailError': 'メールアドレスは必須です',
  'contact.form.emailInvalidError': '有効なメールアドレスを入力してください',
  'contact.form.phone': '電話番号',
  'contact.form.phonePlaceholder': '例: 090-1234-5678',
  'contact.form.category': 'お問い合わせ種別',
  'contact.form.categoryPlaceholder': '選択してください',
  'contact.form.categoryError': 'お問い合わせ種別をお選びください',
  'contact.form.content': 'お問い合わせ内容',
  'contact.form.contentPlaceholder': 'ご質問・ご相談内容をご記入ください（500文字以内）',
  'contact.form.contentError': 'お問い合わせ内容は必須です',
  'contact.form.contentLengthError': '500文字以内で入力してください',
  'contact.form.privacy': 'プライバシーポリシー',
  'contact.form.privacyAgree': 'に同意する',
  'contact.form.privacyError': 'プライバシーポリシーへの同意が必要です',
  'contact.form.submit': '送信する',
  'contact.form.cat.course': 'コースについて',
  'contact.form.cat.pricing': '料金について',
  'contact.form.cat.admission': '入学について',
  'contact.form.cat.seminar': '体験講座について',
  'contact.form.cat.corporate': '法人研修について',
  'contact.form.cat.other': 'その他',

  // PostSubmitGuide
  'contact.post.label': 'AFTER SUBMISSION',
  'contact.post.title': '送信後のご案内',
  'contact.post.subtitleEn': 'What Happens Next',
  'contact.post.lead': 'フォームのご送信後、担当者より2営業日以内にご返信し、ご質問・ご相談に丁寧に対応いたします。',
  'contact.post.step1.title': '自動返信メールをお送りします',
  'contact.post.step1.desc': 'ご入力いただいたメールアドレスに、受付確認の自動返信メールをお送りします。お問い合わせ内容の控えとしてご利用ください。',
  'contact.post.step2.title': '担当者よりご返信いたします',
  'contact.post.step2.desc': 'お問い合わせの内容を確認のうえ、担当者より2営業日以内にご返信いたします。ご質問への回答や、必要なご案内を差し上げます。',
  'contact.post.step3.title': '必要に応じてご案内を継続します',
  'contact.post.step3.desc': 'お問い合わせの内容によっては、個別相談や資料請求、体験講座など、より詳しいご案内を継続して差し上げます。',

  // ContactInfo
  'contact.info.label': 'CONTACT INFORMATION',
  'contact.info.title': '電話・メールでのお問い合わせ',
  'contact.info.subtitleEn': 'Phone & Email',
  'contact.info.lead': 'フォームのほか、お電話・メールでもお問い合わせを承っております。お気軽にご連絡ください。',
  'contact.info.phone': 'お電話',
  'contact.info.phoneHours': '受付 平日10:00〜17:00',
  'contact.info.email': 'メール',
  'contact.info.emailReply': '返信目安: 2営業日以内',
  'contact.info.address': '所在地',
  'contact.info.addressText': '〒135-0064\n東京都江東区青海2-7-4\n東京・お台場',
  'contact.info.accessLink': 'アクセス案内',

  // FAQSection
  'contact.faq.label': 'FAQ',
  'contact.faq.title': 'よくあるご質問',
  'contact.faq.subtitleEn': 'Frequently Asked Questions',
  'contact.faq.footer': '上記で解決しないご質問は、本フォームよりお気軽にお寄せください',
  'contact.faq.0.q': '電話でも問い合わせできますか?',
  'contact.faq.0.a': 'はい。03-6824-4086（受付 平日10:00〜17:00）で承ります。フォーム・メールでもお気軽にどうぞ。',
  'contact.faq.1.q': '返信までどのくらいかかりますか?',
  'contact.faq.1.a': '2営業日以内にご返信します。',
  'contact.faq.2.q': '法人研修の相談もここでできますか?',
  'contact.faq.2.a': '可能ですが、法人研修専用ページにお問い合わせフォームをご用意していますので、そちらがスムーズです。',

  // RelatedPages
  'contact.related.label': 'LEARN MORE',
  'contact.related.title': '関連ページ',
  'contact.related.subtitleEn': 'Explore Further',
  'contact.related.viewMore': '詳しく見る',
  'contact.related.0.title': 'よくある質問',
  'contact.related.0.description': '受講に関するよくあるご質問と回答',
  'contact.related.1.title': '資料請求',
  'contact.related.1.description': '無料の資料をお届け',
  'contact.related.2.title': '個別相談予約',
  'contact.related.2.description': '無料・オンライン可の相談',
  'contact.related.3.title': '法人研修',
  'contact.related.3.description': '企業向けの接遇・ビジネスマナー研修',
};

export default contact;
